export interface ScrollDirection {
    scrollDirection: Ref<'up' | 'down' | null>;
    scrollDown: Ref<boolean>;
    isAtTop: Ref<boolean>;
    velocity: Ref<number>;
    initState: Ref<boolean>;
}

export const injectionSymbolScrollDirection: InjectionKey<ScrollDirection> = Symbol('scrollDirectioninjectionSymbol');
